import {VideoQuality} from "./videoQuality";

/** @internal */
export const VP8_VideoQualities: ReadonlyArray<VideoQuality> = [
    VideoQuality.Create(7680, 4320, 30, "16:9", 0), // 8K
    VideoQuality.Create(3840, 2160, 30, "16:9", 0), // 4K
    VideoQuality.Create(2560, 1440, 30, "16:9", 1), // 2K
    VideoQuality.Create(1920, 1080, 30, "16:9", 3), // FHD
    // VideoQuality.Create(100, 100, 30, "16:9", 3), // FHD
    VideoQuality.Create(1280, 720, 24, "16:9", 5), // HD
    VideoQuality.Create(720, 480, 24, "16:9", 10), // SD
    VideoQuality.Create(720, 480, 15, "16:9", 15), // SD
    VideoQuality.Create(320, 240, 24, "4:3", 20), // QVGA
    VideoQuality.Create(320, 240, 15, "4:3", 40),
    VideoQuality.Create(160, 120, 15, "4:3", 60),
]